import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const EmailIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.06V12.94L4.94 8L0 3.06ZM14.94 2H1.06L8 8.94L14.94 2ZM8.53 10.53C8.39 10.67 8.21 10.75 8 10.75C7.79 10.75 7.61 10.67 7.47 10.53L6 9.06L1.06 14H14.94L10 9.06L8.53 10.53ZM11.06 8L16 12.94V3.06L11.06 8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default EmailIcon;
